<div class="loading-content" role="status" aria-live="polite" aria-busy="true">
  <nz-spin [nzSpinning]="true" nzSize="large" />
  <h3 class="loading-title">{{ resolvedTitle }}</h3>
  <p class="loading-description">{{ resolvedDescription }}</p>
</div>
